var randInt = require('./randInt');
var isArray = require('../lang/isArray');

    /**
     * Returns a random element from the supplied arguments
     * or from the array (if single argument is an array).
     */
    function choice(items) {
        var target = (arguments.length === 1 && isArray(items))? items : arguments;
        return target[ randInt(0, target.length - 1) ];
    }

    module.exports = choice;





/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/random/choice.js
 ** module id = 32
 ** module chunks = 0
 **/